<template>
  <div class="templateFormular">
    <FormModule
      :formIdentifier="formIdentifier"
      @close="closeForm()"
      :editable="false"
      :getFromTraegerschaftAfterCreation="true"
      @afterApiLoad="setzeAbschnitteLokal"
      @afterApiLoadWithError="zeigeFehlermeldung($event)"
    >
      <template v-slot:header>
        <h2>{{ uuid ? 'Template bearbeiten' : 'Template erstellen' }}</h2>
      </template>
      <template v-slot:content>
        <v-row>
          <v-col>
            <b-text-field
              label="Templatename*"
              type="text"
              v-model="name"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col>&nbsp;</v-col>
          <v-col cols="auto">
            <b-btn @click="oeffneVorschau()">
              <v-icon class="pr-2"> mdi-eye </v-icon>
              Vorschau
            </b-btn>
          </v-col>
        </v-row>
        <b-unit no-header>
          <div class="comment">
            <v-row>
              <v-col cols="4" class="pt-6">
                <b-text-area rows="5" label="Anmerkungen zum Fragebogen" v-model="kommentar"></b-text-area>
              </v-col>
            </v-row>
          </div>
          <div class="addedItems">
            <template
              v-for="(abschnitt, abschnitt_index) in abschnitteDTOlokal"
            >
              <div class="abschnitt" :key="abschnitt_index">
                <v-row>
                  <v-col cols="1" class="pt-6"
                    ><h2>{{ abschnitt_index + 1 }}</h2></v-col
                  >
                  <v-col cols="6">
                    <b-text-field
                      label="Abschnittname"
                      type="text"
                      v-model="abschnitt.abschnittname"
                    />
                  </v-col>
                  <v-col cols="2">&nbsp;</v-col>
                  <v-col>
                    <b-btn
                      color="error"
                      @click="zeigeAbschnittLoeschenPopup(abschnitt_index)"
                      rounded
                    >
                      <v-icon class="pr-1"> mdi-delete </v-icon>
                      Abschnitt löschen
                    </b-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="1" class="pt-6"
                    >&nbsp;</v-col
                  >
                  <v-col cols="6" class="pt-6">
                    <b-text-area rows="4" :label="'Anmerkungen zu Abschnitt ' + (abschnitt_index+1)" v-model="abschnitt.kommentar"></b-text-area>
                  </v-col>
                </v-row>
                <!--
                <v-row>
                  <v-col cols="1">&nbsp;</v-col>
                  <v-col cols="5">
                    <b-btn @click="frageHinzufuegen(abschnitt_index, true)" rounded>
                      Frage hinzufügen
                      <v-icon>
                        mdi-plus
                      </v-icon>
                    </b-btn>
                  </v-col>
                </v-row>
                -->
                <v-row>
                  <v-col cols="12">
                    <template v-for="(frage, frage_index) in abschnitt.fragen">
                      <div class="templateFrage" :key="frage_index">
                        <v-row>
                          <v-col cols="1" class="pt-6"
                            ><h3>
                              {{ abschnitt_index + 1 }} . {{ frage_index + 1 }}
                            </h3></v-col
                          >
                          <v-col cols="6">
                            <b-text-field
                              label="Fragestellung"
                              type="text"
                              v-model="frage.fragestellung"
                            />
                          </v-col>
                          <v-col cols="2">&nbsp;</v-col>
                          <v-col>
                            <b-btn
                              color="error"
                              @click="
                                zeigeFrageLoeschenPopup(
                                  abschnitt_index,
                                  frage_index
                                )
                              "
                              rounded
                            >
                              <v-icon class="pr-1"> mdi-delete </v-icon>
                              Frage löschen
                            </b-btn>
                          </v-col>
                        </v-row>
                        <v-row v-if="frage.spaltennamen.length > 0">
                          <v-col cols="1">&nbsp;</v-col>
                          <v-col cols="8">
                            <b-data-table
                              bordered
                              :headers="getHeader(frage.spaltennamen)"
                              :items="[]"
                            ></b-data-table>
                          </v-col>
                          <v-col>
                            <b-btn
                              @click="
                                oeffneSpaltennamenPopup(
                                  abschnitt_index,
                                  frage_index,
                                  frage.spaltennamen
                                )
                              "
                              rounded
                            >
                              <v-icon class="pr-1"> mdi-pencil </v-icon>
                              Spalten bearbeiten
                            </b-btn>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="1">&nbsp;</v-col>
                          <v-col cols="8">
                            <b-btn
                              @click="
                                oeffneSpaltennamenPopup(
                                  abschnitt_index,
                                  frage_index
                                )
                              "
                              rounded
                            >
                              Tabelle hinzufügen
                              <v-icon> mdi-plus </v-icon>
                            </b-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="1">&nbsp;</v-col>
                  <v-col cols="5">
                    <b-btn @click="frageHinzufuegen(abschnitt_index)" rounded>
                      Frage hinzufügen
                      <v-icon> mdi-plus </v-icon>
                    </b-btn>
                  </v-col>
                </v-row>
              </div>
            </template>
            <v-row v-if="weitereVerwendung">
              <v-col>
                <b-text-field
                  label="Boxtext"
                  type="text"
                  v-model="weitereVerwendung"
                />
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="7">
              <v-row>
                <v-col cols="7">
                  <TemplateAddNewItems
                    :weitereVerwendung="weitereVerwendung"
                    @abschnittHinzufuegen="abschnittHinzufuegen"
                    @frageHinzufuegen="frageHinzufuegen($event)"
                    @tabelleHinzufuegen="oeffneSpaltennamenPopup($event)"
                    @auswahlboxHinzufuegen="auswahlboxHinzufuegen"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </b-unit>
      </template>
    </FormModule>
    <TemplateSpaltennamenPopup
      v-if="zeigePopupSpaltennamen"
      :spaltenNamen="spaltenNamenAktiveTabelle"
      @close="zeigePopupSpaltennamen = false"
      @save="tabelleHinzufuegen($event)"
    />
    <TemplateVorschauPopup
      v-if="zeigePopupVorschau"
      :templateVorschau="templateVorschau"
      @close="zeigePopupVorschau = false"
    />
    <LoeschenPopup
      v-if="zeigeLoeschenPopup"
      :text="popupLoeschenText"
      @cancel="zeigeLoeschenPopup = false"
      @delete="elementLoeschen"
    />
    <v-snackbar v-model="showSnackbar" timeout="4000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import FormModule from '@/components/base_components/FormModule';
import TemplateSpaltennamenPopup from '@/components/popups/TemplateSpaltennamenPopup';
import TemplateVorschauPopup from '@/components/popups/TemplateVorschauPopup';
import TemplateAddNewItems from '@/views/templates/TemplateAddNewItems';
import dataMixin from '@/mixins/data-mixin';
import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import LoeschenPopup from '@/components/popups/LoeschenPopup';
import _ from 'lodash';

export default {
  name: 'TemplateFormular',
  components: {
    TemplateAddNewItems,
    FormModule,
    TemplateSpaltennamenPopup,
    TemplateVorschauPopup,
    LoeschenPopup,
  },
  props: {
    uuid: [String],
  },
  mixins: [
    dataMixin('name', 'persistentData.name'),
    dataMixin('abschnitteDTO', 'persistentData.abschnitteDTO'),
    dataMixin('traegerschaft', 'persistentData.traegerschaft'),
    dataMixin('weitereVerwendung', 'persistentData.weitereVerwendung'),
    dataMixin('kommentar', 'persistentData.kommentar'),
    dataMixin('änderungsDatum', 'persistentData.änderungsDatum'),
  ],
  data() {
    return {
      formIdentifier: { type: 'vorlage', uuid: this.uuid },
      abschnitteDTOlokal: [],
      zeigePopupSpaltennamen: false,
      zeigePopupVorschau: false,
      indexAktiverAbschnitt: 0,
      indexAktiveFrage: null,
      spaltenNamenAktiveTabelle: null,
      showSnackbar: false,
      snackbarError: false,
      snackbarText: '',
      templateVorschau: null,
      zeigeLoeschenPopup: false,
      popupLoeschenText: 'Wirklich löschen?',
      hint: 'Pflichtfeld',
      rules: {
        required: (value) => !!value || this.hint,
      },
    };
  },
  computed: {
    ...mapGetters('userData', ['getUserData']),
    snackbarColor: function () {
      return this.snackbarError ? `red` : `primary`;
    },
  },
  methods: {
    ...mapMutations('formData', ['resetFormData']),
    closeForm() {
      this.$router.push('/templates');
    },
    oeffneVorschau() {
      const template = {
        abschnitteDTO: this.abschnitteDTO,
        name: this.name,
        traegerschaft: this.traegerschaft,
        weitereVerwendung: this.weitereVerwendung,
        änderungsDatum: this.änderungsDatum,
        kommentar: this.kommentar
      };
      axios
        .put('/v1/fragebogen/preview', template)
        .then((response) => {
          this.templateVorschau = response.data;
          this.zeigePopupVorschau = true;
        })
        .catch((error) => {
          this.snackbarError = true;
          this.snackbarText = error.response.data;
          this.showSnackbar = true;
        });
    },
    abschnittHinzufuegen() {
      const abschnitt = {
        abschnittname: '',
        fragen: [],
      };
      this.abschnitteDTOlokal.push(abschnitt);
    },
    zeigeAbschnittLoeschenPopup(abschnittIndex) {
      this.popupLoeschenText = 'Wollen Sie den Abschnitt wirklich löschen?';
      this.indexAktiverAbschnitt = abschnittIndex;
      this.indexAktiveFrage = null;
      this.zeigeLoeschenPopup = true;
    },
    frageHinzufuegen(abschnittIndex, vorneEinfuegen = false) {
      if (this.abschnitteDTO.length > 0) {
        const frage = {
          fragestellung: '',
          spaltennamen: [],
        };
        if (vorneEinfuegen) {
          this.abschnitteDTOlokal[abschnittIndex].fragen.unshift(frage);
        } else {
          this.abschnitteDTOlokal[abschnittIndex].fragen.push(frage);
        }
      } else {
        this.snackbarError = true;
        this.snackbarText = 'Es muss zunächst ein Abschnitt erstellt werden';
        this.showSnackbar = true;
      }
    },
    zeigeFrageLoeschenPopup(abschnittIndex, frageIndex) {
      this.popupLoeschenText = 'Wollen Sie die Frage wirklich löschen?';
      this.indexAktiverAbschnitt = abschnittIndex;
      this.indexAktiveFrage = frageIndex;
      this.zeigeLoeschenPopup = true;
    },
    elementLoeschen() {
      if (this.indexAktiveFrage != null && this.indexAktiveFrage >= 0) {
        this.abschnitteDTOlokal[this.indexAktiverAbschnitt].fragen.splice(
          this.indexAktiveFrage,
          1
        );
      } else {
        this.abschnitteDTOlokal.splice(this.indexAktiverAbschnitt, 1);
      }
    },
    oeffneSpaltennamenPopup(
      abschnittIndex,
      frageIndex = 0,
      spaltenNamen = null
    ) {
      if (this.abschnitteDTO.length > 0) {
        if (this.abschnitteDTO[abschnittIndex].fragen.length > 0) {
          this.indexAktiverAbschnitt = abschnittIndex;
          this.indexAktiveFrage = frageIndex;
          if (spaltenNamen) {
            this.spaltenNamenAktiveTabelle = spaltenNamen;
          } else {
            this.spaltenNamenAktiveTabelle = null;
          }
          this.zeigePopupSpaltennamen = true;
        } else {
          this.snackbarError = true;
          this.snackbarText = 'Es muss zunächst eine Frage erstellt werden';
          this.showSnackbar = true;
        }
      } else {
        this.snackbarError = true;
        this.snackbarText = 'Es muss zunächst ein Abschnitt erstellt werden';
        this.showSnackbar = true;
      }
    },
    tabelleHinzufuegen(spaltenNamen) {
      this.abschnitteDTOlokal[this.indexAktiverAbschnitt].fragen[
        this.indexAktiveFrage
      ].spaltennamen = spaltenNamen;
      this.zeigePopupSpaltennamen = false;
    },
    auswahlboxHinzufuegen() {
      this.weitereVerwendung = 'Text Auswahlbox ...';
    },
    getHeader(spaltenNamen) {
      let headers = [];
      spaltenNamen.forEach((element) => {
        headers.push({
          text: element,
          value: element.toLowerCase(),
        });
      });
      return headers;
    },
    setzeAbschnitteLokal() {
      this.abschnitteDTOlokal = this.abschnitteDTO;
    },
    zeigeFehlermeldung(error) {
      this.snackbarError = true;
      this.snackbarText = error.response.data;
      this.showSnackbar = true;
    },
  },
  created() {
    this.resetFormData();
  },
  mounted() {
    if (this.abschnitteDTO === undefined) {
      this.abschnitteDTO = [];
    }
    if (this.uuid === undefined) {
      this.traegerschaft = this.getUserData.projekttraegerschaftName;
    }
  },
  watch: {
    abschnitteDTOlokal: {
      handler: function (newVal, oldVal) {
        this.abschnitteDTO = _.cloneDeep(newVal);
        oldVal;
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.addedItems {
  padding-top: 24px;
  h2 {
    text-align: right;
    padding-right: 20px;
  }
  .templateFrage {
    h3 {
      text-align: right;
    }
  }
}
</style>